import { setCartFirstAddTime, clearCartFirstAddTime } from './cartTimingStorage'
import { logKlaviyoCartDebug, logKlaviyoCartSyncMarker } from './logKlaviyoCartDebug'
import { isKlaviyoCartTrackingEnabled } from './isKlaviyoCartTrackingEnabled'

function getCartStats(cart) {
  const lines = cart?.lines?.edges ?? []
  const itemCount = lines.reduce((sum, { node }) => sum + (node?.quantity ?? 0), 0)
  const value = parseFloat(cart?.cost?.totalAmount?.amount ?? '0')
  const currency = cart?.cost?.totalAmount?.currencyCode ?? 'GBP'

  return { lines, itemCount, value, currency }
}

export function syncCartToKlaviyo(cart, customer, source = 'unknown') {
  if (!isKlaviyoCartTrackingEnabled()) return

  if (!cart || !customer?.email || typeof window === 'undefined' || !window.klaviyo) {
    return
  }

  const { lines, itemCount, value, currency } = getCartStats(cart)
  const isEmpty = lines.length === 0

  logKlaviyoCartSyncMarker(source)

  try {
    const identifyPayload = {
      email: customer.email,
      first_name: customer.firstName,
      last_name: customer.lastName,
      has_cart_items: !isEmpty,
      cart_item_count: itemCount,
      cart_id: isEmpty ? '' : cart.id,
      last_cart_update: cart.updatedAt ?? '',
      cart_value: value,
      cart_currency: currency,
    }

    window.klaviyo.identify(identifyPayload)

    const trackPayload = {
      $value: value,
      cart_item_count: itemCount,
      cart_currency: currency,
      cart_id: cart.id,
    }

    window.klaviyo.track('Cart Updated', trackPayload)

    if (isEmpty) {
      clearCartFirstAddTime(cart.id)
    } else {
      setCartFirstAddTime(cart.id, cart.updatedAt ?? new Date().toISOString())
    }

    logKlaviyoCartDebug('syncCartToKlaviyo', { identifyPayload, trackPayload, isEmpty })
  } catch (error) {
    console.warn('[Klaviyo] syncCartToKlaviyo failed', error)
  }
}
